











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';

@Component
export default class CampaignEntryView extends Vue {
  public items: Common.CampaignEntry[] = new Array(0);
  public params: Common.CampaignEntryQuery = new Common.CampaignEntryQuery();
  public exportQuery = new Common.ExportQuery('キャンペーン応募', this.params);    
  public sortOptions: any = [{ value: 'id', text: 'ID' }];
  @Prop() public campaignId:number;

  public created(){
    if (this.campaignId) {
      this.params.campaignId = this.campaignId;
      this.params.state = Common.CampaignEntryStatus.all;
    }
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj); 
  }  
  public showCampaign(campaignId:string){
      this.$router.push(String.format('/operation/campaign?id={0}',campaignId));
  }  
}
